import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SavingsIcon from "@mui/icons-material/Savings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

export const METRIC_CATEGORY = {
  REACH: "reach",
  IMPACT: "impact",
};

export const DEFAULT_METRIC_CATEGORY = METRIC_CATEGORY.REACH;
export const DEFAULT_METRIC_PAGE = 0;
export const DEFAULT_DISPLAY_ORDER = 0;
export const DISPLAY_ORDER_MIN = 0;
export const DISPLAY_ORDER_STEP = 1;
export const METRIC_TEXT_PREVIEW_LIMIT = 80;

export const METRIC_CATEGORY_OPTIONS = [
  { label: "Reach", value: METRIC_CATEGORY.REACH },
  { label: "Impact", value: METRIC_CATEGORY.IMPACT },
];

export const METRIC_ICON_OPTIONS = [
  {
    value: "heart-handshake",
    label: "Heart & Hands",
    description: "Care/Trust",
    IconComponent: VolunteerActivismIcon,
  },
  {
    value: "trending-up",
    label: "Trending Up",
    description: "Growth",
    IconComponent: TrendingUpIcon,
  },
  {
    value: "shield-check",
    label: "Shield Check",
    description: "Trust/Loyalty",
    IconComponent: VerifiedUserIcon,
  },
  {
    value: "piggy-bank",
    label: "Piggy Bank",
    description: "Savings",
    IconComponent: SavingsIcon,
  },
  {
    value: "wallet",
    label: "Wallet",
    description: "Financial Planning",
    IconComponent: AccountBalanceWalletIcon,
  },
  {
    value: "sparkles",
    label: "Sparkles",
    description: "General/Fallback",
    IconComponent: AutoAwesomeIcon,
  },
];

export const getMetricCategory = (category) =>
  METRIC_CATEGORY_OPTIONS.some((option) => option.value === category)
    ? category
    : DEFAULT_METRIC_CATEGORY;

export const getMetricCategoryLabel = (category) =>
  METRIC_CATEGORY_OPTIONS.find((option) => option.value === category)?.label ||
  "Metric";

export const getMetricIconOption = (iconKey) =>
  METRIC_ICON_OPTIONS.find((option) => option.value === iconKey) ||
  METRIC_ICON_OPTIONS[METRIC_ICON_OPTIONS.length - 1];

export const truncateMetricText = (text) => {
  if (!text) {
    return "-";
  }

  return text.length > METRIC_TEXT_PREVIEW_LIMIT
    ? `${text.substring(0, METRIC_TEXT_PREVIEW_LIMIT)}...`
    : text;
};
